import { request } from "../request";
const mock = "";
// const mock = "https://yapi.upho2015.com/mock/530";

// 获取联报详情
export const getJointInfo = (params) =>
  request(`${mock}/v1/union/get`, "get", { params });
// 计算价格
export const calPrice = (params) =>
  request(`${mock}/v1/order/calPrice`, "post", { json: params });
